// Configuración de URLs para diferentes entornos
export const config = {
  cognito: {
    domain: process.env.VUE_APP_URL_COGNITO || '',
    clientId: process.env.VUE_APP_CLIENT_ID_COGNITO || '',
    scope: 'email openid profile'
  },
  
  // URLs de redirección según el entorno
  getRedirectUri() {
    const hostname = window.location.hostname;
    const frontendHost = process.env.VUE_APP_URL_FRONTEND;
    
    // Si VUE_APP_URL_FRONTEND está definido y coincide con el hostname actual
    if (frontendHost) {
      // Extraer hostname de VUE_APP_URL_FRONTEND (puede venir con o sin protocolo)
      const configuredHost = frontendHost.replace(/^https?:\/\//, '').replace(/\/$/, '');
      
      // Si el hostname actual coincide con el configurado
      if (hostname === configuredHost || hostname === configuredHost.split(':')[0]) {
        // Si es localhost, construir con protocolo, hostname y puerto
        if (hostname === 'localhost') {
          return `${window.location.protocol}//${window.location.hostname}:${window.location.port || '8080'}/`;
        }
        // Para dominios remotos, usar el valor configurado (asegurar protocolo y trailing slash)
        if (frontendHost.startsWith('http')) {
          return frontendHost.endsWith('/') ? frontendHost : `${frontendHost}/`;
        }
        return `https://${frontendHost}/`;
      }
    }
    
    // Fallback: construir dinámicamente según el hostname actual
    if (hostname === 'localhost') {
      return `${window.location.protocol}//${window.location.hostname}:${window.location.port || '8080'}/`;
    }
    
    // Para dominios remotos sin configuración, usar el protocolo y hostname actual (sin puerto)
    return `${window.location.protocol}//${hostname}/`;
  },
  
  // URL completa de login de Cognito
  getLoginUrl() {
    const redirectUri = this.getRedirectUri()
    const params = new URLSearchParams({
      client_id: this.cognito.clientId,
      response_type: 'token',
      scope: this.cognito.scope,
      redirect_uri: redirectUri,
      lang: 'es'
    })
    
    return `${this.cognito.domain}/login?${params.toString()}`
  },
  
  // URL de logout de Cognito (opcional)
  getLogoutUrl() {
    const redirectUri = this.getRedirectUri()
    const params = new URLSearchParams({
      client_id: this.cognito.clientId,
      logout_uri: redirectUri
    })
    
    return `${this.cognito.domain}/logout?${params.toString()}`
  }
}

export default config